import { Flex, IconButton } from "@chakra-ui/react";
import styled from "@emotion/styled";
import * as React from "react";


export const TableIconButton = ({
  icon,
  onClick,
  isDisabled,
  children,
  variantColor,
  ...rest
}) => {
  return (
    <IconButton
      variant="solid"
      colorScheme="blue"
      size="sm"
      {...rest}
      icon={icon}
      onClick={onClick}
      isDisabled={isDisabled}
      aria-label="Table Icon button"
    >
      {children}
    </IconButton>
  );
};

TableIconButton.defaultProps = {
  variantColor: "gray"
};
